import React, { Component } from 'react'
import { CSVLink } from "react-csv";
import * as moment from 'moment'
import L from "leaflet";

class EasinCSV extends Component {

    render() {

        if (!this.props.records || !this.props.records.length) return null

        const headers_csv = [
            { label: "Specie ID", key: "species_id" },
            { label: "Taxonomy", key: "taxonomic_group" },
            { label: "First Year", key: "fYear" },
            { label: "Last Year", key: "lYear" },
            { label: "Latitude", key: "lati" },
            { label: "Longitude", key: "longi" },

        ];

        var array_csv = []

        this.props.records.forEach(record => {

            let rect = L.rectangle(JSON.parse(record.polygon), {})
            let center = rect.getBounds().getCenter()

            array_csv.push({
                species_id: record.speciesName,
                taxonomic_group: record.family,
                fYear: record.yearMin,
                lYear: record.yearMax,
                lati: center.lat.toFixed(6),
                longi:  center.lng.toFixed(6),
            })
        })

        return (
            <span>
            <CSVLink
                data={array_csv}
                filename={`EASIN__${this.props.id_specie}_${moment().format('DD-MM-YYYY')}.csv`}
                headers={headers_csv} separator={";"}
                className="btn btn-success text-dark mt-3 mb-3"
                style={{marginLeft: '1.5rem', fontSize:15}}>
                    {this.props.t("ficha-csv-easin")} ({this.props.records.length})
            </CSVLink>
            </span>
        );
    }
}

export default EasinCSV
